// import { ElementNode, $applyNodeReplacement } from "lexical";

// export class IframeNode extends ElementNode {
//   __src;
//   __width;
//   __height;

//   static getType() {
//     return "iframe";
//   }

//   static clone(node) {
//     return new IframeNode(node.__src, node.__width, node.__height, node.__key);
//   }

//   constructor(src, width = "560", height = "315", key) {
//     super(key);
//     this.__src = src;
//     this.__width = width;
//     this.__height = height;
//   }

//   createDOM() {
//     const wrapper = document.createElement("div");
//     wrapper.style.display = "block";
//     wrapper.style.margin = "16px 0";
//     wrapper.style.width = "100%";

//     const iframe = document.createElement("iframe");
//     iframe.src = this.__src;
//     iframe.width = this.__width;
//     iframe.height = this.__height;
//     iframe.frameBorder = "0";
//     iframe.allowFullscreen = true;
//     iframe.setAttribute(
//       "allow",
//       "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//     );
//     iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
//     iframe.title = "Embedded video";
//     iframe.style.borderRadius = "8px";
//     iframe.style.maxWidth = "100%";

//     wrapper.appendChild(iframe);
//     return wrapper;
//   }

//   updateDOM(prevNode, dom) {
//     const iframe = dom.querySelector("iframe");
//     if (!iframe) return false;
//     if (prevNode.__src !== this.__src) {
//       iframe.src = this.__src;
//     }
//     if (prevNode.__width !== this.__width) {
//       iframe.width = this.__width;
//     }
//     if (prevNode.__height !== this.__height) {
//       iframe.height = this.__height;
//     }
//     return false;
//   }

//   static importDOM() {
//     return {
//       iframe: (domNode) => {
//         const src = domNode.getAttribute("src");
//         if (!src) return null;

//         return {
//           conversion: (domNode) => {
//             const src = domNode.getAttribute("src") || "";
//             const width = domNode.getAttribute("width") || "560";
//             const height = domNode.getAttribute("height") || "315";
//             return { node: new IframeNode(src, width, height) };
//           },
//           priority: 1,
//         };
//       },
//     };
//   }

//   static importJSON(serializedNode) {
//     return new IframeNode(
//       serializedNode.src,
//       serializedNode.width,
//       serializedNode.height
//     );
//   }

//   exportJSON() {
//     return {
//       type: "iframe",
//       version: 1,
//       src: this.__src,
//       width: this.__width,
//       height: this.__height,
//       children: [], // ✅ required for ElementNode
//     };
//   }

//   exportDOM() {
//     const iframe = document.createElement("iframe");
//     iframe.setAttribute("src", this.__src);
//     iframe.setAttribute("width", this.__width);
//     iframe.setAttribute("height", this.__height);
//     iframe.setAttribute("frameborder", "0");
//     iframe.setAttribute("allowfullscreen", "true");
//     return { element: iframe };
//   }

//   isInline() {
//     return false;
//   }
// }

// export function $createIframeNode(src, width = "560", height = "315") {
//   return $applyNodeReplacement(new IframeNode(src, width, height));
// }

// export function $isIframeNode(node) {
//   return node instanceof IframeNode;
// }






import { ElementNode, $applyNodeReplacement } from "lexical";
import { _floatingTooltip } from "../../../../../../utils/utlis"; // adjust path as needed
import { getYoutubeVideoId, withYoutubeJsApi } from "./youtubePlayer";

export class IframeNode extends ElementNode {
    __src;
    __width;
    __height;
    __title;

    static getType() {
        return "iframe";
    }

    static clone(node) {
        return new IframeNode(
            node.__src,
            node.__width,
            node.__height,
            node.__title,
            node.__key
        );
    }

    constructor(src, width = "560", height = "315", title = "YouTube Video", key) {
        super(key);
        this.__src = src;
        this.__width = width;
        this.__height = height;
        this.__title = title;
    }

    createDOM() {
        const wrapper = document.createElement("div");
        wrapper.className = "iframe_node_wrapper";
        wrapper.contentEditable = "false"; // ✅ makes entire wrapper non-editable
        wrapper.style.display = "block";
        wrapper.style.margin = "16px 0";
        wrapper.style.width = "100%";
        wrapper.style.maxWidth = "580px";
        wrapper.style.borderRadius = "12px";
        wrapper.style.overflow = "hidden";
        wrapper.style.border = "1px solid #e0e0e0";
        wrapper.style.boxShadow = "0 2px 12px rgba(0,0,0,0.10)";
        wrapper.style.background = "#fff";
        wrapper.style.position = "relative";

        // ── top bar ──────────────────────────────────────────────
        const topBar = document.createElement("div");
        topBar.className = "iframe_node_topbar";
        topBar.contentEditable = "false"; // ✅ non-editable
        topBar.style.display = "flex";
        topBar.style.alignItems = "center";
        topBar.style.justifyContent = "space-between";
        topBar.style.padding = "10px 14px";
        topBar.style.background = "#fff";
        topBar.style.borderBottom = "1px solid #f0f0f0";
        topBar.style.userSelect = "none"; // ✅ prevents text selection
        topBar.style.webkitUserSelect = "none";

        // title text
        const titleEl = document.createElement("span");
        titleEl.className = "iframe_node_title";
        titleEl.contentEditable = "false"; // ✅ non-editable
        titleEl.textContent = this.__title || "YouTube Video";
        titleEl.style.fontWeight = "600";
        titleEl.style.fontSize = "14px";
        titleEl.style.color = "#222";
        titleEl.style.overflow = "hidden";
        titleEl.style.textOverflow = "ellipsis";
        titleEl.style.whiteSpace = "nowrap";
        titleEl.style.flex = "1";
        titleEl.style.userSelect = "none"; // ✅ prevents text selection
        titleEl.style.pointerEvents = "none"; // ✅ prevents any interaction

        // close button
        const closeBtn = document.createElement("button");
        closeBtn.className = "iframe_node_close";
        closeBtn.dataset.nodeKey = this.getKey();
        closeBtn.contentEditable = "false"; // ✅ non-editable
        closeBtn.innerHTML = "&#x2715;";
        closeBtn.style.background = "none";
        closeBtn.style.border = "none";
        closeBtn.style.cursor = "pointer";
        closeBtn.style.fontSize = "18px";
        closeBtn.style.color = "#888";
        closeBtn.style.lineHeight = "1";
        closeBtn.style.padding = "0 0 0 10px";
        closeBtn.style.flexShrink = "0";
        closeBtn.style.userSelect = "none"; // ✅ prevents selection
        closeBtn.title = "Remove video";

        closeBtn.addEventListener("mouseenter", () => {
            closeBtn.style.color = "#e53935";
        });
        closeBtn.addEventListener("mouseleave", () => {
            closeBtn.style.color = "#888";
        });

        topBar.appendChild(titleEl);
        topBar.appendChild(closeBtn);

        // ── iframe ───────────────────────────────────────────────
        const iframe = document.createElement("iframe");
        // DOM-only: jsapi lets timestamp buttons seek/pause; __src (saved/exported) stays as-is
        iframe.src = withYoutubeJsApi(this.__src);
        iframe.dataset.ytPlayer = "true";
        iframe.dataset.ytId = getYoutubeVideoId(this.__src);
        iframe.width = "100%";
        iframe.height = this.__height;
        iframe.frameBorder = "0";
        iframe.allowFullscreen = true;
        iframe.setAttribute(
            "allow",
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        );
        iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
        iframe.style.display = "block";
        iframe.style.width = "100%";
        iframe.style.pointerEvents = "auto";

        wrapper.appendChild(topBar);
        wrapper.appendChild(iframe);

        return wrapper;
    }

    updateDOM(prevNode, dom) {
        const iframe = dom.querySelector("iframe");
        const titleEl = dom.querySelector(".iframe_node_title");

        if (iframe && prevNode.__src !== this.__src) {
            iframe.src = withYoutubeJsApi(this.__src);
            iframe.dataset.ytId = getYoutubeVideoId(this.__src);
        }
        if (iframe && prevNode.__height !== this.__height) {
            iframe.height = this.__height;
        }
        if (titleEl && prevNode.__title !== this.__title) {
            titleEl.textContent = this.__title;
        }
        return false;
    }

    static importDOM() {
        return {
            iframe: (domNode) => {
                const src = domNode.getAttribute("src");
                if (!src) return null;
                return {
                    conversion: (domNode) => {
                        const src = domNode.getAttribute("src") || "";
                        const width = domNode.getAttribute("width") || "560";
                        const height = domNode.getAttribute("height") || "315";
                        const title = domNode.getAttribute("title") || "YouTube Video";
                        return { node: new IframeNode(src, width, height, title) };
                    },
                    priority: 1,
                };
            },
        };
    }

    static importJSON(serializedNode) {
        return new IframeNode(
            serializedNode.src,
            serializedNode.width,
            serializedNode.height,
            serializedNode.title
        );
    }

    exportJSON() {
        return {
            type: "iframe",
            version: 1,
            src: this.__src,
            width: this.__width,
            height: this.__height,
            title: this.__title,
            children: [],
        };
    }

    exportDOM() {
        const iframe = document.createElement("iframe");
        iframe.setAttribute("src", this.__src);
        iframe.setAttribute("width", this.__width);
        iframe.setAttribute("height", this.__height);
        iframe.setAttribute("title", this.__title);
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "true");
        return { element: iframe };
    }

    isInline() {
        return false;
    }
}

export function $createIframeNode(src, width = "560", height = "315", title = "YouTube Video") {
    return $applyNodeReplacement(new IframeNode(src, width, height, title));
}

export function $isIframeNode(node) {
    return node instanceof IframeNode;
}